import { ApiConstants } from "../../constants/ApiConstants";
import { CHANGE_PASSWORD, FORGETPASSWORD, LOGIN, REGISTER, RESENDOTP, RESETPASSWORD, VERIFYOTP } from "../Constants/AuthContants";
import { createPostDataAction } from "./CommonAction";



// export const CheckUserAction = (payload: any) => createFormDataAction(CHECKUSER, ApiConstants?.Register, payload, true);
export const UserRegisterAction = (payload: any) => createPostDataAction(REGISTER, ApiConstants?.Register, payload, true);
export const VerifyOtpAction = (payload: any) => createPostDataAction(VERIFYOTP, ApiConstants?.VerifyOtp, payload, true);
export const UserLoginAction = (payload: any) => createPostDataAction(LOGIN, ApiConstants?.Login, payload, true);
export const ForgetPasswordAction = (payload: any) => createPostDataAction(FORGETPASSWORD, ApiConstants?.ForgotPassword, payload, true);
export const ResetPasswordAction = (payload: any) => createPostDataAction(RESETPASSWORD, ApiConstants?.ResetPassword, payload, true);
export const ResendOtpAction = (payload: any) => createPostDataAction(RESENDOTP, ApiConstants?.ResendOtp, payload, true);
export const ChangePasswordAction = (payload: any) => createPostDataAction(CHANGE_PASSWORD, ApiConstants?.Changepassword, payload, true);
